import events from 'events';
import $ from '@ali/tarzan-zepto';
// import IScroll from 'iscroll';
import tpl from './tpl.html';
import util from '../../../lib/util';

const isPC = util.isPC();
const pressEvent = isPC ? 'click' : 'tap';

export default class Feedback extends events {
  constructor(app) {
    super();
    this.app = app;
    this.init();
  }

  init() {
    const config = this.app.appConfig;
    this.config = config;
    this.classModifiers = {
      hidden: '-hidden',
      disabled: '-disabled',
      actived: '-actived',
    };
    this.initData();
    this.render();
  }

  initData() {
    window.cscStore = window.cscStore || {};
    this.ratingOptions = window.cscStore.feedback.rating.options;
    this.hasComment = !!window.cscStore.feedback.comment;
    this.state = {
      currentRating: '',
      currentRatingIndex: null,
      reasonsCount: 0,
      comment: '',
      reasons: [],
    };
  }

  toggleReason = (event) => {
    // turn on or off a reason
    const { actived, disabled } = this.classModifiers;
    const $target = $(event.target);
    const index = event.target.getAttribute('data-index');
    const tempState = Object.assign({}, this.state);
    tempState.reasons[index].actived = !tempState.reasons[index].actived;
    // Change status of reason option
    if (tempState.reasons[index].actived) {
      $target.addClass(actived);
    } else {
      $target.removeClass(actived);
    }
    tempState.reasonsCount += tempState.reasons[index].actived ? 1 : -1;
    // Active submit button
    if (tempState.reasonsCount > 0) {
      this.$submit.removeClass(disabled);
    } else {
      this.$submit.addClass(disabled);
    }
    this.state = Object.assign({}, this.state, tempState);
  }

  renderOptions($target = this.$reasonOptions) {
    const { reasons } = this.state;

    if (!reasons) return;

    reasons.map((reason, index) => {
      const { actived } = this.classModifiers;
      const modifer = reason.actived ? ` ${actived}` : '';
      const $option = $(`
        <div
          data-id="${reason.id}"
          data-index="${index}"
          class="csc-feedback _reason-option${modifer}"
        >
          ${reason.content}
        </div>
      `).appendTo($target);
      if (!reason.actived) {
        $option.on(pressEvent, this.toggleReason);
      }
      return false;
    });
  }

  onSubmit = (event) => {
    const { reasonsCount } = this.state;
    if (!reasonsCount) return false;
    const $target = $(event.target);
    const { disabled } = this.classModifiers;
    $target.addClass(disabled);
    // prepare data in state to submit
    const tempState = Object.assign({}, this.state);
    const comment = this.$commentInput.val();
    if (/([^\s])/.test(comment)) {
      tempState.comment = decodeURI(encodeURI(comment).replace(/%0A/g, '<br />'));
    }
    const finalReasons = tempState.reasons.filter(reason => reason.actived);
    tempState.reasons = finalReasons;
    this.state = Object.assign({}, this.state, tempState);

    this.app.on(this.app.events.DONE_FEEDBACK, this.showEndScreen);
    this.app.emit(this.app.events.SUBMIT_FEEDBACK, this.submitFeedback());
    return false;
  }

  submitFeedback = () => {
    const { comment, reasons, currentRating } = this.state;
    // Submit feedback data to server
    const feedbackData = {
      rating: {
        id: currentRating,
        reasons,
      },
      comment,
    };
    return feedbackData;
  };

  showInputScreen() {
    /*
      show reasons to pick from current type data
    */
    const bodyView = this.app.view.body;
    const { hidden } = this.classModifiers;
    this.$inputScreen.removeClass(hidden);
    this.renderOptions(this.$reasonOptions);
    this.$submit.on(pressEvent, this.onSubmit);

    bodyView.refresh();
    bodyView.scrollToBottom();
  }

  showEndScreen = () => {
    /*
      render comment
      render chosen reasons
      hide input screen
      show end screen
    */
    const { hidden } = this.classModifiers;
    const { comment } = this.state;
    if (comment) {
      this.$commentContent.html(comment);
    } else {
      this.$comment.addClass(hidden);
    }
    this.renderOptions(this.$chosenReasons);
    this.$inputScreen.addClass(hidden);
    this.$endScreen.removeClass(hidden);
    this.app.view.body.refresh();
  };

  assignElements() {
    this.$rating = this.$node.find('#csc-feedback-rating');
    this.$comment = this.$node.find('#csc-feedback-comment');
    this.$commentContent = this.$node.find('#csc-feedback-comment-content');
    this.$commentInput = this.$node.find('#csc-feedback-comment-input');
    this.$inputScreen = this.$node.find('#csc-feedback-input-screen');
    this.$endScreen = this.$node.find('#csc-feedback-end-screen');
    this.$ratingType = this.$node.find('#csc-feedback-current-rating-type');
    this.$reasonMandatory = this.$node.find('#csc-feedback-reason-mandatory');
    this.$reasonOptions = this.$node.find('#csc-feedback-reason-options');
    this.$chosenReasons = this.$node.find('#csc-feedback-chosen-reasons');
    this.$submit = this.$node.find('#csc-feedback-submit');
  }

  onRate = (event) => {
    const id = event.target.getAttribute('data-id');
    const index = event.target.getAttribute('data-index');
    this.state = Object.assign({}, this.state, {
      currentRating: id,
      currentRatingIndex: index,
      reasons: this.ratingOptions[index].reasons.options,
    });
    this.endRateScreen();
  }

  endRateScreen() {
    /*
      highlight clicked type button, disable click events
      show content text of current type
      go to next screen
    */
    const { actived, disabled } = this.classModifiers;
    const { currentRating } = this.state;

    this.ratingOptions.map((rating) => {
      const { id } = rating;
      const $button = this.$node.find(`[data-id="${id}"]`);
      if (id === currentRating) {
        const { content, reasons } = rating;
        $button.addClass(actived);
        this.$ratingType.html(content);
        this.$reasonMandatory.html(reasons.title);
      } else {
        $button.addClass(disabled);
      }
      $button.off(pressEvent);
      return false;
    });

    this.showInputScreen();
  }

  renderRatingButtons() {
    // render rate buttons depend on data, bind pick event
    this.ratingOptions.map((rating, index) => {
      const { id, type } = rating;
      const $button = $(`<div
          data-id="${id}"
          data-index=${index}
          class="csc-feedback _rate-button -${type}"
        ></div>`);
      $button.insertBefore(this.$ratingType);
      $button.on(pressEvent, this.onRate);
      return true;
    });
  }

  initView() {
    const { hidden } = this.classModifiers;
    // Render rating buttons
    this.renderRatingButtons();
    // If there no comment data from feedback store -> hide comment
    if (!this.hasComment) {
      this.$comment.addClass(hidden);
      this.$commentInput.addClass(hidden);
    }
  }

  render() {
    const renderData = {
      boxTitle: 'Rate your experience',
      submitButtonText: 'Submit',
      enterComments: 'Enter comments…',
      thanks: 'Thank you for your support',
    };
    // RENDER EVALUATION
    const $node = $(tpl.render(renderData));
    this.$node = $node;
    this.assignElements();
    this.initView();
    window.feedbackNode = $node;
    this.app.view.body.append($node);
    // Scroll chat window to bottom
    this.app.view.scrollToBottom();
  }

  initScroller(data, $node) {
    console.log('init ', data, $node);
  }

  doResize() {
    const $node = this.$node;
    const config = this.app.appConfig;
    const data = config.get('recommend');
    const pageWidth = $node.width() + 24;
    const num = data.banner.length;
    $node.find('.J_Banner').css({
      width: pageWidth,
      height: 110,
    });
    $node.find('.J_Scroller').css('width', pageWidth * num);
    $node.find('.J_Indicator').css('width', 12 * (num - 1) + 6);
    if (data.banner && data.banner.length > 0) {
      this.initScroller(data, $node);
      // 开始自动滚动banner
      this.bannerScroller.scrollIntervalId = this.setAutoScroll();
    }
    this.bannerScroller.refresh();
  }

  resize() {
    setTimeout(() => {
      if (window.feedbackNode) {
        this.doResize();
      } else {
        this.resize();
      }
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/module/feedback/feedback.js